export const staticRequisiteHistoryLocaleDict = {
    ru: {
        historyTitle: 'История изменения {0}'
    },
    en: {
        historyTitle: 'Change history: {0}'
    },
    th: {
        historyTitle: 'ประวัติการเปลี่ยนแปลง: {0}'
    },
    tr: {
        historyTitle: 'Değişiklik geçmişi: {0}'
    }
};
